 <template >
     <div class="card"  ref="screen" v-if="toggle.visibleFlag === true" style="height: 100%">
        <div class="card-header d-flex justify-content-between">
            <div class="">{{toggle.vizTitle}}</div>
            
            <div v-on:click="toggleCheckbox(checkbox)">
                <i class="fa fa-toggle-off fa-2x" style="color:grey" v-if="checkbox">
                <p style="font-size:0.5em">Fixed Scale</p></i>
                <i class="fa fa-toggle-on fa-2x" style="color:grey" v-if="!checkbox">
                <p style="font-size:0.5em">Flexi Scale</p></i>
            </div>

            <a href="#" role="button" id="fullscreen">
            <i class="fas fa-expand-alt"></i></a>

             <a href="#" role="button" id="download">
               <i class="fa fa-download"></i></a>

            <a v-on:click="commentBox(toggle)" class="txt-color-white right-padding-50">
                <i class="fa fa-lg fa-comments"></i>
            </a>
        </div>
        <div class="card-body cScroll1" >
            <div :id="id" ref="r1c1"></div>
        </div>

        <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
            <b-form-group label="Comment">
                <textarea rows="3" cols="40" v-model="cmnt"
                          placeholder="Write a comment..."></textarea>
            </b-form-group>
        </b-modal>
    </div>
</template>
<script>
import {FwVizChartInfo} from "../models";
import axios from "axios";
import $ from "jquery";

export default {
        name: 'Toggle',
        props: {
            toggle: Object
        },
        data: () => ({
            showFSButton:true,
            showModal: false,
            cmnt: "",
            annotations: [],
            searching: false,
            annotationTitle: '',
            id: `VIZ-${new Date().getTime()}`,
            checkbox:false,
        }),

        created() {
            this.toggleCheckbox()
            this.$store.dispatch("loadState").then(() => {
                let allVizType = this.$store.state.vizType
                let v = this.toggle
                let margin = {
                    top: v.pmTop,
                    right: v.pmRight,
                    bottom: v.pmBottom,
                    left: v.pmLeft
                }
                // console.log(" 84 toggle",this.checkbox)
                let vizId = v.viztypeId
                let filter = allVizType.filter(t => t.viztypeId === vizId)[0];
                let vizname = filter.viztypeClassName
                console.log("vizName in vue",vizname)
                let vizFunction = filter.viztypeFunctionName
                let divId = this.$refs.r1c1
                let vizunit = v.positionLogical

                let getChartInfo = (vizunit) => {
                    let f = v
                    if (f.length === 0) return new FwVizChartInfo(vizunit, margin, {}, false, [])
                    return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f)
                }

                this.position = getChartInfo(vizunit)

                let chartData = this.position
                //this.$commonFn.renderChart(vizname, chartData, divId, 'mpcbarChartFixedRange');
                this.$commonFn.renderChart(vizname, chartData, divId, vizFunction);
            })
        },

        mounted() {
            $("#fullscreen").on('click',function (el) {
                el.preventDefault();
                console.log("sdncvchsvd chgvcvwyjvdhvasxyts")
                console.log(el)

                if ($(this).children('i').hasClass('fa-expand-alt')) {
                      $(this).children('i').removeClass('fa-expand-alt');
                      $(this).children('i').addClass('fa-compress-alt');
                } else if ($(this).children('i').hasClass('fa-compress-alt')) {
                      $(this).children('i').removeClass('fa-compress-alt');
                      $(this).children('i').addClass('fa-expand-alt');
                }
                $(this).closest('.card').toggleClass('fullscreen');
            })
        },
        methods: {
            fullscreen(showFSButton) {
                if(showFSButton===true) {
                    console.log(showFSButton)
                    this.$refs.screen.requestFullscreen();
                } else {
                     console.log(showFSButton)
                     const document=window.document
                     document.exitFullscreen();
                }
                this.showFSButton=!this.showFSButton
            },
            toggleCheckbox: function(checkbox) {
                console.log("enter inti checkbx",checkbox)
                this.$store.dispatch("loadState").then(() => {
                    let allVizType = this.$store.state.vizType
                    let v = this.toggle
                    let margin = {
                        top: v.pmTop,
                        right: v.pmRight,
                        bottom: v.pmBottom,
                        left: v.pmLeft
                    }
                    // console.log(" 84 toggle",this.checkbox)
                    let vizId = v.viztypeId
                    let filter = allVizType.filter(t => t.viztypeId === vizId)[0];
                    // let vizname = filter.viztypeName
                    let vizname = filter.viztypeClassName
                    console.log("vizName in vue",vizname)
                    let vizFunction = filter.viztypeFunctionName
                    let divId = this.$refs.r1c1
                    let vizunit = v.positionLogical
                    let getChartInfo = (vizunit) => {
                        let f = v
                        if (f.length === 0) return new FwVizChartInfo(vizunit, margin, {}, false, [])
                        return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f)
                    }

                    this.position = getChartInfo(vizunit)

                    let chartData = this.position
                    this.$commonFn.renderChartCompare(vizname, chartData, divId, vizFunction,this.checkbox);
                    this.checkbox=!this.checkbox
                })
            },

            commentBox: function (what) {
                console.log(`ENTERED into the commentBox function(${what.menuName}, ${what.screenName})`)
                this.cmt = '';
                this.pg = what.menuName;
                this.section = what.screenTitle;
                this.annotationHeader = "User Annotations";
                this.annotationTitle = this.annotationHeader + '->' + this.pg + '->' + this.section
                this.$refs['comment-box'].show()
            },

            postAnnotation: function () {
                const url = '/api/annotation';
                const data = {
                    userId: 1,
                    userName: "Admin",
                    page: this.pg,
                    section: this.section,
                    comment: this.cmnt
                };
                axios.post(url, data).then(() => {
                       this.$store.dispatch('loadAnnotations')
                }, e => {
                 //   this.$commonFn.auditLog(this.toggle.menuSyspk,menu, subMenu, "", "POST", e)
                    console.error('error in updating annotations', e)
                })
                let menu = this.pg;
                let subMenu = this.section;
                console.log("the menus and submenus for Audit log is", menu, subMenu)

               // this.$commonFn.auditLog(this.toggle.menuSyspk,menu, subMenu, "", "POST", "Success")
            }
        }
    }
</script>
<style>
   /* .cScroll1{
        height: 500px;
        overflow: scroll;
    } */
    div.fullscreen {
        z-index: 0;
        position:fixed;
        width: 100%;
        height: 100%;
        top: 67px;
        right: 0;
        left: 0;
        bottom: -50px;
    }
</style>